import React, {useState} from "react";
import {db} from './firebase';
import firebase from './firebase';
import { useForm } from 'react-hook-form';
import {addZwrotAkcji} from './features/addedZwrotAkcjiSlice';
import { useDispatch } from 'react-redux';

function AddZwrotAkcji()  {
const dispatch = useDispatch();
const { handleSubmit, register } = useForm();

const onSubmit = (formData) => {
  db.collection('addedZwrotAkcji').add(
      {
          name: formData.zwrotAkcji,
          type: "zwrotAkcji",
          timestamp: firebase.firestore.FieldValue.serverTimestamp()
      });

      dispatch(addZwrotAkcji({
        zwrotAkcji: formData.zwrotAkcji
      })
      )
      document.getElementById("my-form-zwrot").value='';
};

  {
    return (
      <form onSubmit={handleSubmit(onSubmit)} className="add-co-sie-stalo" >

      <input 
      id="my-form-zwrot"
      name='zwrotAkcji'
      type="text" 
      placeholder="Dodaj zwrot akcji" 
      className="no-background"
      ref={register({required: true})}
      />
      <button type="submit">Send</button>

    </form>
    )
  }
}

export default AddZwrotAkcji;
